import { styled } from '@linaria/react'
import React, { FC, ReactNode } from 'react'
import QuestionIcon from '../svgr/Faq'
import { colors } from '../styles/colors'
import { Typography } from './Typography'

interface InfoHintProps {
  children: ReactNode
  className?: string
}

export const InfoHint: FC<InfoHintProps> = ({ children, className }) => {
  return (
    <Container className={className}>
      <IconContainer>
        <InfoIcon />
      </IconContainer>

      <Typography fontSize={12} fontWeight={400} font="roboto">
        {children}
      </Typography>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${colors.grey100};
  border-radius: 100px;
  padding: 8px 12px;
  width: 100%;
`

const IconContainer = styled.div`
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.textPrimary};
`

const InfoIcon = styled(QuestionIcon)`
  width: 100%;
  height: 100%;
`
